import { DividerStyleEnum, Alignment } from '@teko/types/shared';
import React__default from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';
import { pixelParse } from '../../helpers/utils.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Divider = (_a) => {
  var _b = _a, {
    width = "100%",
    height = "1px",
    color = "black",
    dividerStyle = DividerStyleEnum.solid,
    align,
    gap,
    alignContent,
    spacingContent,
    orientation = "horizontal",
    children
  } = _b, rest = __objRest(_b, [
    "width",
    "height",
    "color",
    "dividerStyle",
    "align",
    "gap",
    "alignContent",
    "spacingContent",
    "orientation",
    "children"
  ]);
  const renderSeparator = () => {
    if (!children) {
      return /* @__PURE__ */ React__default.createElement(WrapperSeparator, {
        width,
        weight: height,
        dividerStyle,
        color,
        align,
        orientation
      });
    }
    return /* @__PURE__ */ React__default.createElement(WrapperSeparatorText, {
      width,
      weight: height,
      dividerStyle,
      color,
      align,
      alignContent,
      spacingContent,
      orientation
    }, /* @__PURE__ */ React__default.createElement("span", null, children));
  };
  return /* @__PURE__ */ React__default.createElement(WrapperDivider, __spreadProps(__spreadValues({}, rest), {
    gap,
    orientation
  }), renderSeparator());
};
const WrapperDivider = styled.div(({ gap, orientation }) => [
  CommonStyles,
  `
      --divider-gap: ${pixelParse(gap != null ? gap : "") || "12px"};
      display: flex;
      ${orientation === "vertical" ? `
          flex-direction: column;
          writing-mode: vertical-rl;
        ` : ``}
      padding-block: var(--divider-gap)
    `
]);
const transformAlign = (align) => {
  switch (align) {
    case Alignment.center:
      return "margin: 0 auto;";
    case Alignment.right:
      return `
        margin: 0 auto;
        margin-right: 0;
      `;
    default:
      return "";
  }
};
const transformAlignContent = (alignContent, orientation) => {
  if (orientation === "vertical") {
    const css = `
      {
        display: block;
        content: "";
        flex-grow: 1;
        border-left: var(--divider-border-block);
      }
    `;
    switch (alignContent) {
      case Alignment.left:
        return `&:after ${css}`;
      case Alignment.right:
        return `&:before ${css}`;
      default:
        return `&:before ${css}; &:after ${css}`;
    }
  } else {
    const css = `
      {
        display: block;
        content: "";
        flex-grow: 1;
        border-top: var(--divider-border-block);
      }
    `;
    switch (alignContent) {
      case Alignment.left:
        return `&:after ${css}`;
      case Alignment.right:
        return `&:before ${css}`;
      default:
        return `&:before ${css}; &:after ${css}`;
    }
  }
};
const WrapperSeparator = styled.div(({ width, weight, dividerStyle, color, align, theme, orientation }) => `
    display: flex;
    --divider-border-block: ${weight || "1px"} ${dividerStyle} ${(theme == null ? void 0 : theme.colors[color]) || color || (theme == null ? void 0 : theme.colors.divider)};
    ${orientation === "vertical" ? `
        height: ${width || "100%"};
        border-left: var(--divider-border-block);
      ` : `
        width: ${width || "100%"};
        border-top: ${weight || "1px"} ${dividerStyle} ${(theme == null ? void 0 : theme.colors[color]) || color || (theme == null ? void 0 : theme.colors.divider)};
      `}
    ${transformAlign(align || Alignment.left)}
  `);
const WrapperSeparatorText = styled.div(({
  width,
  weight,
  dividerStyle,
  color = "black",
  align,
  alignContent,
  spacingContent,
  theme,
  orientation = "horizontal"
}) => `
    --divider-border-block: ${weight || "1px"} ${dividerStyle} ${(theme == null ? void 0 : theme.colors[color]) || color || (theme == null ? void 0 : theme.colors.divider)};
    --divider-content-spacing: ${spacingContent || "10px"};
    display: flex;
    align-items: center;
    ${orientation === "vertical" ? "flex-direction: column;" : ""}
    ${orientation === "vertical" ? `height: ${width || "100%"};` : `width: ${width || "100%"};`}
    ${transformAlign(align || Alignment.left)}
    ${transformAlignContent(alignContent || Alignment.center, orientation)}

    > span {
      display: inline-block;
      margin: ${orientation === "vertical" ? `var(--divider-content-spacing) 0` : `0 var(--divider-content-spacing)`};
    }
  `);
Divider.displayName = "Divider";

export { Divider };
